import React from 'react';
import {
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    Navigate,
} from 'react-router-dom';
import Wrapper from './components/Wrapper';
import Error from './Pages/Errors';
import HomePage from './Pages/Home';

const router = createBrowserRouter(createRoutesFromElements(
    <Route element={<Wrapper />} errorElement={<Error />}>
        <Route index element={<HomePage />} />
        <Route path={'cancel'} element={<HomePage type='cancelled' />} />
        <Route path={'success'} element={<HomePage type='success' />} />
        <Route path={'fail'} element={<HomePage type='failed' />} />
    </Route>
));

export default router;